import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import "font-awesome/css/font-awesome.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons";
import { DatePicker } from "reactstrap-date-picker";

import AuthService from "services/auth.service";
import moment from "moment";
import Select from "react-select";
import { booleanList, statusList } from "content/static";
import { logsList } from "api";
import { handleSorting } from "utils/utils";
import SelectComponent from "components/form/Select";
import logClient from "lib/log-client";
import LogModel from "./LogaModal";
import TableComponent from "./Table";
import HeaderComponent from "./Header";

const dateFormate = (date) => !date || date === "" ? "" : moment(date).format("YYYY-MM-DD")
const paramCreate = (page_no, limit, fromDate, toDate, logFrom, logType, software, validationchecked) => {
  const selFromlog = logFrom.map(_state => _state.value)
  const selSoftLog = software.map(_state => _state.value)
  return ({ page_no, limit, fromDate, toDate, logFrom: selFromlog, logType, software: selSoftLog, validationchecked })
}
const Logs = () => {
  const [loading, setLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [rowData, setRows] = useState(undefined);
  const [theadData, setTheadData] = useState([]);
  const [tbodyData, setTbodyData] = useState([]);
  const [totalRows, setTotalRows] = useState();
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [masterList, setMasterList] = useState([]);
  const [softwareList, setSoftwareList] = useState([]);

  // Modal open state
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const getLogData = async (paramsd) => {
    setLoading(true);
    try {
      const ResData = await logsList(paramsd); //response.json();
      const { data, totalcount, totalpages } = ResData.data;
      if (data) {
        // getRowsData(data);
        setRows(data);
        setTableData(data);
        // setAllRows(data)
        setTotalRows(totalcount);
        setPage(paramsd.page_no);
        setPageCount(totalpages);
        // ReactTooltip.rebuild();
      } else {
        AuthService.logout();
      }
    } catch (err) {
      // console.log("LOGS ERROR: " + err);
    }
    setLoading(false);
  };

  const handlePageClick = (event) => {
    getLogData(paramCreate(event.selected + 1, pageLimit, fromDate, toDate, currSelValue, statusSelValue, softSelValue, validSelValue));
  };

  const getLists = async () => {
    setLoading(true);
    const { master, software, error } = await logClient.filterList()
    setMasterList(master);
    setSoftwareList(software);
    setLoading(false);
  };

  const [sortField, setSortField] = useState("");
  const [order, setOrder] = useState("asc");
  const handleSortingChange = (accessor) => {
    const sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    setSortField(accessor);
    setOrder(sortOrder);

    const sorted = handleSorting(accessor, sortOrder, tableData);
    if (sorted) {
      setRows(sorted);
    }
  };

  const [errorMsg, setErrorMsg] = useState({});
  const [logDataFrom, setLogDataFrom] = useState();

  const clickView = (logText, logMessage, logFrom, type) => {
    setModal(!modal);
    setTheadData(Object.keys(logText?.[0] || {}));
    setTbodyData(logText);
    setErrorMsg({ type, logMessage });
    setLogDataFrom(logFrom);
  };

  const clickReload = () => {
    getLogData(paramCreate(1, 20, "", "", [], "", [], ""));
    selectSoftRef.current.clearValue();
    selectSortRef.current.clearValue();
    setFromDate("");
    setToDate("");
    setStatusSelValue("");
    setValidSelValue("");
    setPage(1);
    setPageLimit(20);
  };



  const clickSearch = () => {
    getLogData(paramCreate(1, pageLimit, fromDate, toDate, currSelValue, statusSelValue, softSelValue, validSelValue));
  };

  const selectSortRef = useRef(null);
  const selectSoftRef = useRef();

  const [currSelValue, setCurrSelValue] = useState([]);
  const [statusSelValue, setStatusSelValue] = useState("");
  const [softSelValue, setSoftSelValue] = useState([]);
  const [validSelValue, setValidSelValue] = useState("");
  const [pageLimit, setPageLimit] = useState(20);

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const setFromDatez = (d) => setFromDate(dateFormate(d))
  const setToDatez = (d) => setToDate(dateFormate(d))

  useEffect(() => {
    if (!rowData) {
      getLists();
      getLogData(paramCreate(page, 20, "", "", [], "", [], ""));
    }
  }, []);
  return (
    <>
      <Container fluid className="px-4 py-2">
        <Row>
          <Col lg="12">
            <div className="smartTable-container row">
              <div className="col-12 pt-2">
                {loading && (
                  <div className="smartTable-loaderContainer text-primary">
                    <div className="spinner-border" role="status"></div>
                  </div>
                )}
                <div className="row">
                  <div className="col h4">Log Details</div>

                  <div className="col">
                    <Select
                      defaultValue={""}
                      onChange={setSoftSelValue}
                      options={softwareList}
                      isMulti={true}
                      ref={selectSoftRef}
                      placeholder="Select Software"
                      className="softstyle"
                    />
                  </div>

                  <div className="col">
                    <DatePicker
                      id="from-datepicker"
                      value={fromDate}
                      onChange={(date, format) => setFromDatez(date)}
                      dateFormat={"DD/MM/YYYY"}
                      placeholder="From date"
                    />
                  </div>
                  <div className="col">
                    <DatePicker
                      id="to-datepicker"
                      value={toDate}
                      onChange={(date, format) => setToDatez(date)}
                      dateFormat={"DD/MM/YYYY"}
                      placeholder="To date"
                    />
                  </div>
                  <div className="col">
                    <Select
                      defaultValue={currSelValue}
                      onChange={setCurrSelValue}
                      options={masterList}
                      isMulti={true}
                      ref={selectSortRef}
                      placeholder="Select Master"
                    />
                  </div>

                  <SelectComponent
                    className="col"
                    selectClassName={"form-control"}
                    optionList={statusList}
                    value={statusSelValue}
                    onChange={(e) => setStatusSelValue(e.target.value)}
                    firstOption={"Select Status"}
                  />

                  <SelectComponent
                    className="col"
                    selectClassName={"form-control"}
                    optionList={booleanList}
                    value={validSelValue}
                    onChange={(e) => setValidSelValue(e.target.value)}
                    firstOption={"Select Validation"}
                  />

                  <div className="col">
                    <Button className="btn btn-info" onClick={clickSearch}>
                      Search
                    </Button>
                  </div>

                  <div className="col">
                    <div className="pull-right">
                      {/*<p className="pull-right form-control text-center"><strong className="text-success">{totalRows}</strong></p>*/}
                      {/*<JsonToExcel
                                  title= {<FontAwesomeIcon icon={faFileExcel}/>}
                                  data={rowData}
                                  fileName={"logdetails_"+moment(new Date()).format("YYYY-MM-DD_h:mm:a")}
                                  btnClassName="btn"
                                />*/}
                      <Button className="btn btn-warning" onClick={clickReload}>
                        <FontAwesomeIcon icon={faArrowRotateRight} />
                      </Button>
                    </div>
                  </div>
                </div>

                <HeaderComponent
                  rowData={rowData}
                  pageCount={pageCount}
                  totalRows={totalRows}
                  pageLimit={pageLimit}
                  setPageLimit={setPageLimit}
                  handlePageClick={handlePageClick}
                />
                <TableComponent
                  order={order}
                  rowData={rowData}
                  sortField={sortField}
                  clickView={clickView}
                  handleSortingChange={handleSortingChange}
                />
              </div>
            </div>
            <LogModel
              modal={modal}
              toggle={toggle}
              errorMsg={errorMsg}
              tbodyData={tbodyData}
              theadData={theadData}
              logDataFrom={logDataFrom}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};


export default Logs;
